import { create } from "zustand";
import {
	SingleSendEmail,
	SingleSendEmailActions,
	SingleSendEmailState,
} from "./types";

export const useSingleSendEmailStore = create<
	SingleSendEmailState & SingleSendEmailActions
>((set) => ({
	singleSendEmail: null,
	update: (state: SingleSendEmail | null) => set({ singleSendEmail: state }),
}));
